import styled from 'styled-components';

import { PADDING_PAGE } from '../../../globals';


export const StyledOfficeStats = styled.div`
  padding: ${PADDING_PAGE}px;
`;



// WEBPACK FOOTER //
// ./src/components/OfficeStats/styles/StyledOfficeStats.js